import React, { createContext, useState, useContext, useEffect } from 'react';

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState(null);
  const userId = localStorage.getItem('userID');

  const fetchProfileImage = async () => {
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetProfileImage?ID=${userId}`
      );
      if (response.ok) {
        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);
        setProfileImage(imageUrl);
      }
    } catch (error) {
      console.error('Error fetching profile image:', error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchProfileImage();
    }
  }, [userId]);

  const refreshProfileImage = () => {
    fetchProfileImage();
  };

  return (
    <ProfileContext.Provider value={{ profileImage, refreshProfileImage }}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);